<template>
  <section class="flex flex-col gap-4 w-full">
    <div
      class="flex gap-2 flex-col flex-1 px-0 py-2 rounded-xl w-full"
      v-for="(p, idx) in players"
      :key="idx"
      :class="[idx % 2 === 0 ? 'bg-[#D388CA]' : 'bg-[#EA96A2]']"
    >
      <div class="flex text-center justify-start items-center px-2 gap-4">
        <div class="text-primary text-lg font-semibold leading-none">{{ p.name }}</div>
        <div v-if="p.legScore > 0" class="text-xs rounded-full h-5 gold-gradient px-2">
          {{ p.legScore }} Leg{{ p.legScore > 1 ? 's' : '' }}
        </div>
      </div>

      <div class="gap-2 font-bold text-2xl flex items-stretch justify-around w-full px-2">
        <span class="bg-primary rounded-full px-2 py-2 min-w-[70px] text-center">
          {{ Math.ceil(playerScoreCounts[idx] / 3) }}
        </span>
        <span class="bg-primary rounded-full px-2 py-2 min-w-[70px] text-center">
          {{ playerScoreCounts[idx] }}
        </span>
        <span class="bg-primary rounded-full px-2 py-2 min-w-[70px] text-center">
          {{ legDuration }}
        </span>
        <span class="bg-primary rounded-full px-2 py-2 min-w-[70px] text-center">
          {{ Math.round((playerScores[idx] / playerScoreCounts[idx]) * 3) }}</span
        >
      </div>
      <div
        class="gap-2 font-bold text-primary flex items-stretch justify-around w-full text-xs text-center"
      >
        <span class="min-w-[70px]">Rounds</span>
        <span class="min-w-[70px]">Darts</span>
        <span class="min-w-[70px]">Leg Time</span>
        <span class="min-w-[70px]">3 Dart Avg</span>
      </div>
    </div>
  </section>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps({
  players: {
    type: Array,
    default: () => [],
  },

  history: {
    type: Array,
    default: () => [],
  },

  legDuration: {
    type: String,
    default: '',
  },
});

const playerScoreCounts = computed(() => {
  const counts = Array(props.players.length).fill(0);
  props.history.forEach((entry) => {
    if (entry.player !== undefined && entry.player < counts.length) {
      counts[entry.player]++;
    }
  });
  return counts;
});

const playerScores = computed(() => {
  const counts = Array(props.players.length).fill(0);
  props.history.forEach((entry) => {
    if (entry.player !== undefined && entry.player < counts.length) {
      counts[entry.player] += entry.scoredValue;
    }
  });
  return counts;
});
</script>
